import TableOnly from "components/DataTable/TableOnly";
import Pagination from "components/Pagination/Pagination";
import SearchComp from "components/SearchComp/SearchComp";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "../../../../components/DeleteModalBtn/DeleteModalButton";
import { useEffect, useState, useRef } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import { parseFloatData } from "utils/UtilityFuncs";
import SelectMaterialList from "../Purchase/SelectMaterialList";
import SelectMaterialLot from "./SelectMaterialLot";

let API_URL = "/manufacturer-issues/";
let COMPONENT_URL = "/manufacturer/material-stock";
let COMPONENT_DETAILS_URL = "/manufacturer/material-stock";

let filterBy = [
  { name: "All", value: "all" },
  { name: "ID", value: "issueId" },
  { name: "Lot ID", value: "lotId" },
  { name: "Order Id", value: "orderId" },
];
let limits = [5, 10, 15, 20];

export default function Issues() {
  const user = useSelector((state) => state.user?.userInfo);

  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  /*   ALL STATES
   ********************************************* */

  const [issueData, setIssueData] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  const [loading, setLoading] = useState(false);

  const [materialListData, setMaterialListData] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);

  const [purchaseHistory, setPurchaseHistory] = useState(null);
  const [selectedPurchaseLot, setSelectedPurchaseLot] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const [showMaterialModal, setShowMaterialModal] = useState(false);

  const [searchResults, setSearchResults] = useState(null);

  const [totalPages, setTotalPages] = useState(
    parseInt(searchParams.get("totalPages")) || 1
  );

  if (searchParams.get("limit") === null) {
    setSearchParams((prev) => {
      let limit = searchParams.get("limit") || "10";
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", limit);
      return newParams.toString();
    });
  }
  if (searchParams.get("page") === null) {
    setSearchParams((prev) => {
      let page = searchParams.get("page") || "1";
      const newParams = new URLSearchParams(prev);
      newParams.set("page", page);
      return newParams.toString();
    });
  }
  if (searchParams.get("filterBy") === null) {
    setSearchParams((prev) => {
      let filterBy = searchParams.get("filterBy") || "all";
      const newParams = new URLSearchParams(prev);
      newParams.set("filterBy", filterBy);
      return newParams.toString();
    });
  }

  const [startDate, setStartDate] = useState(() => {
    const now = new Date();
    return new Date(now.getFullYear() - 1, now.getMonth(), 2)
      .toISOString()
      .slice(0, 10)
      .replace("T", " ");
  });

  const [endDate, setEndDate] = useState(
    new Date().toISOString().slice(0, 10).replace("T", " ")
  );

  const [showDateFilter, setShowDateFilter] = useState(false);

  // Ref for Order ID input
  const orderIdInputRef = useRef(null);

  /*   All Functions
   ********************************************* */

  const changeLimit = (val) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", val);
      return newParams.toString();
    });
  };

  const handleFilterBy = (filter) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("filterBy", filter);
      return newParams.toString();
    });
  };

  const getSearchParamsWithoutGivenKey = (key) => {
    let params = new URLSearchParams(searchParams);
    params.delete(key);

    return params.toString();
  };

  //get Ext Transaction Data
  const getIssueData = async () => {
    try {
      setLoading(true);
      // increment 1 to endDate
      const endDateObj = new Date(endDate);
      // get only date frm endDateObj not time
      const endDateString = endDateObj.toISOString().slice(0, 10);

      if (!selectedMaterial?.id) {
        setIssueData([]);
        return;
      }

      let page = parseInt(searchParams.get("page")) || 1;
      let limit = parseInt(searchParams.get("limit")) || 10;
      let query = searchParams.get("query") || "";
      let filterBy = searchParams.get("filterBy") || "all";

      let body = { page, limit, filterBy };

      // check for sort and order in searchParams
      let sort = searchParams.get("sort");
      let order = searchParams.get("order");
      if (sort && order) {
        body.sort = sort;
        body.order = order;
      }

      if (query) {
        body.query = query;
      }

      if (startDate) {
        body.startDate = startDate;
      }
      if (endDate) {
        body.endDate = endDateString;
      }
      if (selectedMaterial?.id) {
        body.materialId = selectedMaterial?.materialId;
      }

      const { data } = await API.post(
        API_URL + selectedPurchaseLot?.lotId,
        body,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setIssueData(data?.data);
        setTotalPages(data?.totalPages);
        setSearchResults(null);
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Delete
  const deleteIssueData = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.delete("/manufacturer-issue/" + id, {
        headers: authHeader(),
      });
      if (data?.success) {
        setIssueData((prev) => prev.filter((item) => item.id !== id));
        dispatch(
          setNotification({
            message: data?.message,
            type: "success",
          })
        );
        setRefresh(true);
        return;
      }
      dispatch(
        setNotification({
          message: data?.message,
          type: "error",
        })
      );
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      reset();
    }
  };

  // Adds Button Function
  const AddIssueData = async (e) => {
    e.preventDefault();

    try {
      if (!selectedMaterial?.id) {
        dispatch(
          setNotification({
            message: "Please select a material",
            type: "error",
          })
        );
        return;
      }
      if (!selectedPurchaseLot?.lotId) {
        dispatch(
          setNotification({
            message: "Please select a purchase lot",
            type: "error",
          })
        );
        return;
      }
      if (!formData?.type) {
        dispatch(
          setNotification({
            message: "Please select a transaction type",
            type: "error",
          })
        );
        return;
      }

      let body = {
        ...formData,
        materialId: selectedMaterial?.materialId,
        lotId: selectedPurchaseLot?.lotId,
        styleId: selectedMaterial?.styleId,
      };

      setLoading(true);
      const { data } = await API.post("/manufacturer-issue", body, {
        headers: authHeader(),
      });

      if (data?.success) {
        setIssueData((prev) => [...prev, data?.data]);
        setFormData({
          ...formData,
          type: "issue",
          orderId: "",
          qty: "",
        });
        setRefresh(true);
        // Focus on Order Id input after successful add
        setTimeout(() => {
          if (orderIdInputRef.current) {
            orderIdInputRef.current.focus();
          }
        }, 100);
        // setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      reset();
    }
  };

  // Update Button Function
  const UpdateIssueData = async (e) => {
    e.preventDefault();

    try {
      if (!selectedMaterial?.id) {
        dispatch(
          setNotification({
            message: "Please select a material",
            type: "error",
          })
        );
        return;
      }
      if (!selectedPurchaseLot?.lotId) {
        dispatch(
          setNotification({
            message: "Please select a purchase lot",
            type: "error",
          })
        );
        return;
      }
      if (!formData?.type) {
        dispatch(
          setNotification({
            message: "Please select a transaction type",
            type: "error",
          })
        );
        return;
      }

      let body = {
        ...formData,
        purchasedQty: selectedPurchaseLot?.originalAvailableQty,
        materialId: selectedMaterial?.materialId,
        lotId: selectedPurchaseLot?.lotId,
        styleId: selectedMaterial?.styleId,
      };

      // setLoading(true);
      const { data } = await API.patch("/manufacturer-issue", body, {
        headers: authHeader(),
      });
      if (data?.success) {
        dispatch(
          setNotification({
            message: data?.message,
            type: "success",
          })
        );
        setIssueData((prev) => {
          const newData = prev.map((item) => {
            if (item.id === formData.id) {
              return data?.data;
            }
            return item;
          });
          return newData;
        });
        setRefresh(true);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      await getIssueData();
      reset();
      setShowAddModal(false);
    }
  };

  const handleUpdateData = async (item) => {
    setFormData(item);
    setIsUpdateMode(true);
    setShowAddModal(true);
  };

  const reset = () => {
    setFormData((prev) => ({
      ...prev,
      type: "issue",
      orderId: "",
      qty: "",
    }));
    setLoading(false);
    setIsUpdateMode(false);
    // setShowAddModal(false);
    setSelectedPurchaseLot((prev) => {
      return {
        ...prev,
        originalAvailableQty: prev?.qty || 0,
      };
    });
  };

  // Getting 12 Hours Time from SQL timestamp
  const convertSqlTimestampToDate = (sqlTime) => {
    const timestamp = sqlTime;
    const date = new Date(timestamp);
    const time = date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return time;
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    setSelectedPurchaseLot((prev) => null);
    setIssueData((prev) => null);
    setSearchResults((prev) => null);
  }, [selectedMaterial]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      let _filterBy = searchParams.get("filterBy") || "all";
      let _query = searchParams.get("query") || "";
      if (_filterBy && _filterBy !== "all" && !_query) {
        return;
      }

      if (selectedPurchaseLot?.id) {
        setFormData({
          ...formData,
          type: "issue",
        });
        getIssueData();
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [selectedPurchaseLot, searchParams]);

  useEffect(() => {
    if (isUpdateMode && selectedPurchaseLot?.id) {
      setSelectedPurchaseLot((prev) => {
        return {
          ...prev,
          originalAvailableQty: selectedPurchaseLot?.qty + (formData?.qty || 0),
        };
      });
    }
  }, [isUpdateMode]);

  // if purchaseHistory changes then update selectedPurchaseLot to new updated purchaseHistory
  useEffect(() => {
    let lotId = searchParams.get("lotId");
    if (lotId && purchaseHistory) {
      let updatedLot = purchaseHistory.find(
        (lot) => lot.lotId === parseInt(lotId)
      );
      if (updatedLot) {
        setSelectedPurchaseLot((prev) => updatedLot);
      }
      return;
    }
    if (purchaseHistory && purchaseHistory?.length > 0 && selectedPurchaseLot) {
      let updatedLot = purchaseHistory.find(
        (lot) => lot.lotId === selectedPurchaseLot.lotId
      );
      if (updatedLot) {
        setSelectedPurchaseLot((prev) => updatedLot);
      }
    }
  }, [purchaseHistory, searchParams]);

  useEffect(() => {}, []);

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <div>
      <>
        <button
          onClick={() => {
            setShowAddModal(true);
            setFormData({
              type: "issue",
              issueDate: new Date().toISOString().slice(0, 10),
            });
            setSelectedPurchaseLot((prev) => {
              return {
                ...prev,
                originalAvailableQty: prev?.qty || 0,
              };
            });
            setIsUpdateMode(false);
          }}
          disabled={
            loading || !selectedMaterial?.id || !selectedPurchaseLot?.id
          }
          type="button"
          className="btn btn-primary  ms-1"
        >
          Issue
        </button>
      </>
    </div>
  );

  const table_head = [
    { name: "T-ID", value: "tid" },
    { name: "Lot ID", value: "lotId" },
    { name: "Style ID", value: "styleId" },
    { name: "Qty", value: "qty" },
    { name: "Order Id", value: "orderId" },
    { name: "Issue Date", value: "issueDate" },
    { name: "Actions", value: "Actions" },
  ];

  const table_body = (item, index) => (
    <tr
      className={`${
        searchParams?.get("tid") === item?.tid?.toString()
          ? "bg-primary bg-opacity-25 align-middle py-0"
          : "align-middle py-0"
      }`}
      key={item.id}
    >
      <td className="align-middle py-0">{item?.tid}</td>
      <td className="align-middle py-0">{item?.lotId}</td>
      <td className="align-middle py-0">{item?.m_materialList?.styleId}</td>
      <td className="align-middle py-0 text-start">{item?.qty}</td>
      <td className="align-middle py-0 text-start">{item?.orderId}</td>
      <td className="align-middle py-0">
        {convertSqlTimestampToDate(item?.issueDate)}
      </td>

      <td className="align-middle py-0">
        {!item?.returnQty && (
          <button
            disabled={loading || !selectedPurchaseLot?.id}
            onClick={() => {
              handleUpdateData(item);
            }}
            className="btn px-1"
          >
            <i className="mdi mdi-pencil"></i>
          </button>
        )}

        <DeleteModalButton
          btnClass={"btn px-1"}
          deleteFunc={deleteIssueData}
          deleteParams={item.id}
          disableConditions={loading}
        />
      </td>
    </tr>
  );

  useEffect(() => {
    let getMaterialId = searchParams.get("materialId");

    if (!selectedMaterial?.id && getMaterialId) {
      async function fetchData() {
        try {
          setLoading(true);

          const { data } = await API.post(
            "manufacturer-material-lists/" + getMaterialId,
            { filterBy: "all" },
            {
              headers: authHeader(),
            }
          );
          if (data?.success) {
            setSelectedMaterial(data?.data);
          }
        } catch (err) {
          dispatch(
            setNotification({
              message: err.message,
              type: "error",
            })
          );
        } finally {
          setLoading(false);
        }
      }
      fetchData();
    }
  }, [selectedMaterial, searchParams]);

  return (
    <div className="">
      {loading && <Spinner />}
      {/*   Table
       ********************************************* */}
      <div className="pe-2 flex-grow-1 gap-3">
        <div className="d-flex justify-content-between align-items-center gap-3">
          <div
            style={{
              height: "70vh",
              width: "40%",
            }}
          >
            <div className="bg-light mb-3 py-2 px-3 rounded-3 shadow-sm d-flex justify-content-between align-items-center">
              <h4 className="">
                {selectedMaterial
                  ? `Selected Material (${selectedMaterial?.styleId})`
                  : "Please select a Material"}
              </h4>
              <button
                onClick={() => setShowMaterialModal(true)}
                className="btn btn-primary "
              >
                {selectedMaterial ? "Change Material" : "Select Material"}
              </button>
            </div>
            <SelectMaterialLot
              refresh={refresh}
              setRefresh={setRefresh}
              selectedMaterialId={selectedMaterial?.materialId}
              purchaseHistory={purchaseHistory}
              setPurchaseHistory={setPurchaseHistory}
              selectedPurchaseLot={selectedPurchaseLot}
              setSelectedPurchaseLot={setSelectedPurchaseLot}
            />
          </div>
          <div
            style={{
              height: "72vh",
              width: "60%",
            }}
            className="horizontal-scrollable"
          >
            {/* Table */}
            {selectedMaterial && selectedPurchaseLot && (
              <>
                <div className="">
                  <div className="d-flex justify-content-end align-items-center mb-3">
                    <div className="flex-grow-1 d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center gap-1">
                        <div>Show</div>
                        <button
                          className="px-1 bg-primary bg-opacity-10 border border-primary rounded-end rounded-start "
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {searchParams.get("limit")}
                        </button>
                        <ul
                          style={{ width: "fit-content" }}
                          className="dropdown-menu"
                        >
                          {limits.map((limit) => (
                            <li key={limit}>
                              <button
                                className="dropdown-item"
                                onClick={() => changeLimit(limit)}
                              >
                                {limit}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="d-flex align-items-center">
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="primary"
                            id="dropdown-basic"
                            className="bg-opacity-10 border border-primary rounded-end rounded-start"
                          >
                            {filterBy.find(
                              (filter) =>
                                filter.value === searchParams.get("filterBy") ||
                                (searchParams.get("filterBy") === null &&
                                  filter.value === "all")
                            )?.name || "Filter By"}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {filterBy.map((filter) => (
                              <Dropdown.Item
                                key={filter.value}
                                onClick={() => handleFilterBy(filter.value)}
                              >
                                {filter.name}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                        {/* Filter By Date */}
                        <Dropdown
                          className="d-inline"
                          align={{ lg: "end" }}
                          show={showDateFilter}
                          autoClose={false}
                        >
                          <Dropdown.Toggle
                            onClick={() => setShowDateFilter(!showDateFilter)}
                            className="btn btn-success mx-2"
                            id="dropdown-autoclose-false"
                          >
                            Filter by Date
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="bg-white shadow-lg pt-3 rounded mt-1">
                            <div
                              className="m-2 my-1 "
                              style={{ minWidth: 250 }}
                            >
                              {/* From */}
                              <div className="row mt-2">
                                <div className="col-3  d-flex justify-content-start ms-1 align-items-center ">
                                  <div className="">From</div>
                                </div>
                                <div className="col-8 px-0">
                                  <input
                                    className="form-control"
                                    value={startDate || ""}
                                    onChange={(e) =>
                                      setStartDate(e.target.value)
                                    }
                                    type={"date"}
                                  />
                                </div>
                              </div>
                              {/* To */}
                              <div className="row">
                                <div className="col-3  d-flex justify-content-start ms-1 align-items-center ">
                                  <div className="">TO</div>
                                </div>
                                <div className="col-8 px-0">
                                  <input
                                    className="form-control"
                                    value={endDate || ""}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    type={"date"}
                                  />
                                </div>
                              </div>
                              <div className="d-flex justify-content-end mt-2 ">
                                <button
                                  onClick={() => {
                                    getIssueData();
                                    setShowDateFilter(!showDateFilter);
                                  }}
                                  className="btn btn-success mb-1 btn-sm mx-2"
                                >
                                  FILTER
                                </button>
                              </div>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                    <SearchComp
                      setLoading={setLoading}
                      apiPath={`${COMPONENT_URL}${
                        getSearchParamsWithoutGivenKey("query")
                          ? "?" + getSearchParamsWithoutGivenKey("query") + "&"
                          : "?"
                      }`}
                    />
                    <div className="ms-1">{btn1()}</div>
                  </div>
                  {searchResults ? (
                    <TableOnly
                      table_head={table_head}
                      table_body={table_body}
                      table_data={searchResults}
                      totalPages={totalPages}
                    />
                  ) : (
                    <TableOnly
                      table_head={table_head}
                      table_body={table_body}
                      table_data={issueData}
                      totalPages={totalPages}
                    />
                  )}
                  {loading && <Spinner />}
                  {!searchResults && (
                    <Pagination
                      totalPages={totalPages}
                      apiPath={`${COMPONENT_URL}${
                        searchParams.toString()
                          ? "?" + getSearchParamsWithoutGivenKey("page") + "&"
                          : "?"
                      }page=`}
                      currPage={parseInt(searchParams.get("page")) || 1}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/*   Change Material Modal
       ********************************************* */}
      <Modal
        size="lg"
        show={showMaterialModal}
        onHide={() => setShowMaterialModal(false)}
        contentClassName="bg-transparent"
      >
        <Modal.Body className="bg-white px-3 pb-4 custom-shadow-sm rounded-3">
          <div className="d-flex justify-content-between align-items-center ">
            <h3>Change Material</h3>
            <button
              onClick={() => {
                setShowMaterialModal(false);
              }}
              className="btn btn-secondary btn-sm"
            >
              Close
            </button>
          </div>
          <hr className="mt-0 mb-3" />
          <SelectMaterialList
            selectedMaterial={selectedMaterial}
            setSelectedMaterial={setSelectedMaterial}
            materialListData={materialListData}
            setMaterialListData={setMaterialListData}
            showModal={setShowMaterialModal}
          />
        </Modal.Body>
      </Modal>

      {/*   Add Modal
       ********************************************* */}
      <Modal show={showAddModal} onHide={() => reset()} style={{ left: -300 }}>
        <Modal.Body
          className="shadow-lg bg-white px-3 "
          style={{ borderRadius: 15 }}
        >
          <div className="">
            <h4>{isUpdateMode ? "Update Issue Order" : "Issue To Order"} </h4>
          </div>
          <hr className="mt-0" />
          <form
            onSubmit={isUpdateMode ? UpdateIssueData : AddIssueData}
            className=""
          >
            {/* Show Selected Material and Selected Purchase Lot  */}
            <div className="mb-3">
              <label className="form-label">Selected Material & Lot</label>
              <div className="d-flex gap-2">
                <span className="badge bg-primary  px-3 py-1 fs-4">
                  Material :
                  {selectedMaterial?.styleId || "No Material Selected"}
                </span>
                <span className="badge bg-secondary  px-3 py-1 fs-4">
                  Lot Id: {selectedPurchaseLot?.lotId || "No Lot Selected"}
                </span>
              </div>
            </div>

            {/*Issue Date  */}
            <div className="mb-3">
              <label htmlFor="issueDate" className="form-label">
                Issue Date
              </label>
              <input
                type="date"
                className="form-control"
                id="issueDate"
                value={formData.issueDate}
                onChange={(e) =>
                  setFormData({ ...formData, issueDate: e.target.value })
                }
                placeholder="Enter Issue Date"
                required
              />
            </div>

            {/* Order Id */}
            <div className="mb-3">
              <label htmlFor="orderId" className="form-label">
                Order Id
              </label>

              <input
                ref={orderIdInputRef}
                type="text"
                className="form-control"
                id="orderId"
                value={formData.orderId || ""}
                onChange={(e) =>
                  setFormData({ ...formData, orderId: e.target.value })
                }
                placeholder="Enter Order Id"
                required
              />
            </div>

            {/* Issue Qty */}
            <div className="mb-3">
              <label htmlFor="qty" className="form-label">
                Quantity ( Available Qty:{" "}
                {selectedPurchaseLot?.originalAvailableQty
                  ? selectedPurchaseLot?.originalAvailableQty
                  : selectedPurchaseLot?.qty || 0}
                )
              </label>
              <input
                type="number"
                step="0.001"
                max={
                  selectedPurchaseLot?.originalAvailableQty
                    ? selectedPurchaseLot?.originalAvailableQty
                    : selectedPurchaseLot?.qty || 0
                }
                className="form-control"
                id="qty"
                value={formData.qty || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    qty: parseFloatData(e.target.value),
                  })
                }
                placeholder="0.000"
                required
              />
            </div>

            {/*   buttons
             ********************************************* */}
            <div className="mt-3">
              <div className="d-flex justify-content-end">
                <button
                  onClick={() => {
                    reset();
                    setShowAddModal(false);
                  }}
                  className="btn btn-secondary btn-sm"
                  type="button"
                >
                  Close
                </button>
                <button
                  disabled={loading}
                  className="btn btn-primary btn-sm ms-1"
                  type="submit"
                >
                  {isUpdateMode ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
